@let commonData = commonDataService.getData() | async;

<div class="d-flex align-items-center justify-content-between">
  <div class="d-flex flex-column">
    <img src="/assets/images/trustpilot.webp" alt="trustpilot" width="100" height="20" />
    <img src="/assets/images/members.webp" alt="members" width="152" height="32" class="mt-2" />
  </div>

  <div class="d-flex flex-column align-items-center px-3 py-2 badge">
    <h2 class="semi-bold">{{ commonData?.trustpilotRate }}</h2>
    <p class="semi-bold">Excellent</p>
  </div>
</div>

<p class="mt-3">
  Thousands of travelers say our service is<br />exceptional — and we’re committed to<br />delivering
  outstanding value and unbeatable<br />prices.
</p>
